import tacklebox from "tacklebox";

import { Page } from "@/js/Page.js";

function CompanyPage() {
  Page.call(this, "company", "運営会社");
}
tacklebox.design.extend(CompanyPage, Page);

CompanyPage.prototype._onInitialize = function () {};
export { CompanyPage };
